var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitoringChartActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  *[fill=\"#242222\"]{fill:#FFFFFF !important;}\n  *[stroke=\"#242222\"]{stroke:#FFFFFF !important;}\n  *[fill]:not([fill=\"#242222\"]){fill:none !important;}\n  *[stroke]:not([stroke=\"#242222\"]){stroke:none !important;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8182 1.45447H2.18184C1.38184 1.45447 0.727295 2.10901 0.727295 2.90901V17.5272C0.727295 18.3272 1.38184 18.9817 2.18184 18.9817H21.8182C22.6182 18.9817 23.2728 18.3272 23.2728 17.5272V2.90901C23.2728 2.10901 22.6182 1.45447 21.8182 1.45447ZM21.8182 15.4908C21.8182 15.6726 21.6364 15.8545 21.4546 15.8545H2.54548C2.32729 15.8545 2.18184 15.6726 2.18184 15.4908V3.27265C2.18184 3.09083 2.32729 2.90901 2.54548 2.90901H21.4546C21.6364 2.90901 21.8182 3.09083 21.8182 3.27265V15.4908Z",
    fill: "#61C2E9",
    stroke: "#242222",
    strokeWidth: 0.545455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.1455C12.4016 18.1455 12.7273 17.8199 12.7273 17.4182C12.7273 17.0165 12.4016 16.6909 12 16.6909C11.5983 16.6909 11.2727 17.0165 11.2727 17.4182C11.2727 17.8199 11.5983 18.1455 12 18.1455Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23632 21.2H14.7272C15.4545 21.2 16.0727 21.7818 16.0727 22.5454H7.89087C7.89087 21.7818 8.50905 21.2 9.23632 21.2Z",
    fill: "#F85647",
    stroke: "#242222",
    strokeWidth: 0.545455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52734 18.9818H14.4728V21.1636H9.52734V18.9818Z",
    stroke: "#242222",
    strokeWidth: 0.545455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 9.63639C18.9091 12.0364 16.0727 13.8909 15.4182 14.2909C15.3454 14.3273 15.2363 14.3273 15.1636 14.2909C14.5091 13.8909 11.6727 12.0364 11.3818 9.63639C11.2363 8.43639 12.0363 7.27276 13.2363 7.1273C14.0727 7.01821 14.8727 7.45457 15.2727 8.10912C15.6727 7.45457 16.4727 7.01821 17.3091 7.1273C18.5454 7.27276 19.3454 8.43639 19.2 9.63639Z",
    fill: "#F85647"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0728 10.6182H13.2364L13.6 9.7091L14.2182 12.1818L14.8728 8.69092L15.6728 12.8L16.2909 10L17.0182 11.7818L17.5273 10.6182H20.4",
    stroke: "white",
    strokeWidth: 0.545455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40008 5.5999V6.03627C6.40008 6.10899 6.32736 6.18172 6.25463 6.18172H5.49099C5.41827 6.18172 5.34554 6.25445 5.34554 6.32717V7.09081C5.34554 7.16354 5.27281 7.23627 5.20008 7.23627H4.76372C4.69099 7.23627 4.61827 7.16354 4.61827 7.09081V6.32717C4.61827 6.25445 4.54554 6.18172 4.47281 6.18172H3.70918C3.63645 6.18172 3.56372 6.10899 3.56372 6.03627V5.5999C3.56372 5.52717 3.63645 5.45445 3.70918 5.45445H4.47281C4.54554 5.45445 4.61827 5.38172 4.61827 5.30899V4.54536C4.61827 4.47263 4.69099 4.3999 4.76372 4.3999H5.20008C5.27281 4.3999 5.34554 4.47263 5.34554 4.54536V5.30899C5.34554 5.38172 5.41827 5.45445 5.49099 5.45445H6.25463C6.36372 5.49081 6.40008 5.52717 6.40008 5.5999Z",
    fill: "#F85647"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19995 7.16357H11.2363",
    stroke: "#242222",
    strokeWidth: 0.545455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19995 5.52722H9.49086",
    stroke: "#242222",
    strokeWidth: 0.545455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96362 8.79993H8.36362",
    stroke: "#242222",
    strokeWidth: 0.545455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96362 10.4363H8.36362",
    stroke: "#242222",
    strokeWidth: 0.545455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96362 12.109H8.36362",
    stroke: "#242222",
    strokeWidth: 0.545455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96362 13.7454H8.36362",
    stroke: "#242222",
    strokeWidth: 0.545455,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoringChartActive);
export default __webpack_public_path__ + "static/media/monitoring Chart Active.04ae722ce976cfd15a3711dd84d0593e.svg";
export { ForwardRef as ReactComponent };